import type { Provider } from '@unipile/types';
import { createContext } from 'react';

export type ProviderContextType = {
  provider: Provider;
  provider_name: string;
  provider_icon: string;
  product_icons?: Readonly<Record<string, string>>;
};

export const ProviderContext = createContext<ProviderContextType | undefined>(undefined);
ProviderContext.displayName = 'ProviderContext';
